import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '功能介绍', path: '/category/features' },
  { label: '使用教程', path: '/category/tutorials' },
  { label: '用户评价', path: '/category/reviews' },
  { label: '常见问题', path: '/category/faq' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled && !mobileOpen
          ? 'bg-transparent'
          : 'bg-background-50 border-b border-background-200'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-16">
        <Link
          to="/"
          className={`text-xl font-bold whitespace-nowrap ${
            isHome && !scrolled && !mobileOpen
              ? 'text-background-50'
              : 'text-foreground-900'
          }`}
        >
          91c
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? isHome && !scrolled
                    ? 'text-background-50 bg-white/20'
                    : 'text-primary-600 bg-primary-50'
                  : isHome && !scrolled
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
            isHome && !scrolled && !mobileOpen
              ? 'text-background-50'
              : 'text-foreground-700'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 text-sm font-medium rounded-md transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}